import {
    AUDIENCE_TARGETINGS_TEMPLATE_NAME_CHANGE,
    AudienceTargetingsEditorAction,
    CLOSE_AUDIENCE_TARGETINGS,
    OPEN_AUDIENCE_TARGETINGS_EDITOR,
    RESET_AUDIENCE_TARGETINGS
} from '../../actions/targetings/audience';
import { AudienceTargetingsEditorState } from '../../typings/audienceTargetings';
import { AudienceTargetingsEditorsState } from '../../typings/state';

export const defaultAudienceTargetingsEditorsState: AudienceTargetingsEditorState = {
    isOpen: false,
    templateName: ''
};

export const audienceTargetingsEditorsInitialState: AudienceTargetingsEditorsState = {};

export function audienceTargetingsEditor(
    state: AudienceTargetingsEditorsState = audienceTargetingsEditorsInitialState,
    action: AudienceTargetingsEditorAction
): AudienceTargetingsEditorsState {
    switch (action.type) {
        case OPEN_AUDIENCE_TARGETINGS_EDITOR: {
            return {
                ...state,
                [action.id]: {
                    templateName: action.value,
                    isOpen: true
                }
            };
        }

        case RESET_AUDIENCE_TARGETINGS:
        case CLOSE_AUDIENCE_TARGETINGS: {
            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    isOpen: false
                }
            };
        }

        case AUDIENCE_TARGETINGS_TEMPLATE_NAME_CHANGE:
            const editor = state[action.id];

            return {
                ...state,
                [action.id]: {
                    ...editor,
                    templateName: action.value
                }
            };

        default:
            return state;
    }
}
